import React, {useContext} from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AceHighwayManifest'
import Box from '@material-ui/core/Box'
import AceHighwayManifestApiUrls from 'src/apiUrls/AceHighwayManifestApiUrls'
import FaxCoverSheetFormProperties from './FaxCoverSheetFormProperties'
import { useFormContext } from 'react-hook-form'
import { FileForUserGetCurrentLoginId } from 'src/common/FileForUserCommon'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
   CngForm
  },
  CngDialog,
} = components

const { FormState } = constants

function FaxCoverSheetDialog(props) {
  const {
    openDialog,
    onClose,
    showNotification
  } = props

  const { initialValues, makeValidationSchema } = FaxCoverSheetFormProperties.formikProps
  const {securedSendRequest } = useServices()
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 
  //const { translate } = useTranslation(Namespace.ACEHWY_MANIFEST)
  //const translatedTextsObject = makeTranslatedTextsObject()
  // const { getValues, trigger } = useFormContext()

  /*function makeTranslatedTextsObject() {
    let faxTitle = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.FAX_COVERSHEET
    )

    let sendButton = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_BUTTON
    )

    let sendCoverSheetSuccessfulMsg = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_COVER_SHEET_SUCCESSFUL_MSG
    )

    let sendCoverSheetFailedMsg = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      ManifestKeys.SEND_COVER_SHEET_FAILED_MSG
    )


    return { 
      faxTitle, 
      sendButton, 
      sendCoverSheetSuccessfulMsg,
      sendCoverSheetFailedMsg
    }
  }*/

  function handleEmailCoverSheet(data){
    try {
      securedSendRequest.execute(
        'POST',
        AceHighwayManifestApiUrls.FAX_COVERSHEET,
        data,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (!errorMessages) {
                showNotification(
                  'success',
                  aceHighwayManifestTranslationText.sendCoverSheetSuccessfulMsg
                )
                onClose()
              } else {
                errorMessages.forEach((message) =>
                  showNotification('error', message)
                )
              }
            }
          }
        },
        () => {
          showNotification('error', aceHighwayManifestTranslationText.sendCoverSheetFailedMsg)
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          formikProps={{
            initialValues: {
              ...(initialValues)
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
                data.tripNo = openDialog.data && openDialog.data.tripNo
                data.partyId = openDialog.data && openDialog.data.partyId
                data.userId = FileForUserGetCurrentLoginId()
                data.includeQRCode = openDialog.data && openDialog.data.includeQRCode
                handleEmailCoverSheet(data)
                onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FaxCoverSheetFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              tripNo={openDialog.data && openDialog.data.tripNo}
            />
          )}
          // renderButtonSection={() => (
          //   <Box display='flex' justifyContent='flex-end'>
          //     <CngButton color='primary' size='medium' type='submit'
          //     onClick={async () => {
          //         const result = await trigger()
          //         if (result) {
          //           if (window.confirm('Please be advised you are sending an empty trip (with no shipments to CBSA). Do you want to proceed?')) {
          //             handleEmailCoverSheet(getValues())
          //           }
          //         }
          //       }}
          //       variant='contained'
          //       size='medium'
          //       // shouldShowProgress={loading}
          //     >
          //       {aceHighwayManifestTranslationText.sendButton}
          //     </CngButton>
          //   </Box>
          // )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {aceHighwayManifestTranslationText.sendButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={aceHighwayManifestTranslationText.faxTitle}
      // fullWidth
      // maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={openDialog.open}
      shouldShowCloseButton
    />
  )
}

export default FaxCoverSheetDialog
